export * from './side-menu-page.component';
